import { TagGroup } from "../../../shared/models/tagGroup.model.ts";
import { getToken } from "../../../shared/utils/common.tsx";
import { TemplateTagSerializer } from "../serializers/templateTagSerializer.ts";

export class CommandGetTagsLinked {
  async run(adId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ads/${adId}/tags/`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${getToken()} `,
        },
      })
        .then((response) => response.json())
        .then((json) => json)
        .catch((err) => console.log(err));
      if (response) {
        return this.deserialize(response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): TagGroup[] {
    const serializer = new TemplateTagSerializer();
    return serializer.deserializeList(data);
  }
}
